// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[name=\"lottery_number\"][data-v-16b56ae5] {\n  letter-spacing: .5em;\n}\n", ""]);
// Exports
module.exports = exports;
